export default __webpack_public_path__ + "static/media/anvandaforkortningar2.706f2ab9.png";